import React from 'react'
import {Document, Page, View} from "@react-pdf/renderer"

import {baseStyles} from "../../styles"
import {AmountDueAtSigningPDF} from "../../components/AmountDueAtSigningPDF"
import {PaymentInformationPDF} from "../../components/PaymentInformationPDF"
import {TaxInformationPDF} from "../../components/TaxInformationPDF"
import {VehicleInfoPDF} from "../../components/VehicleInfoPDF"
import {ResidualInformationPDF} from "../../components/ResidualInformationPDF"
import {MileageInformationPDF} from "../../components/MileageInformationPDF"
import {HeaderPDF} from "../../components/HeaderPDF"
import {FeeBreakdownPDF} from "../../components/FeeBreakdownPDF"
import {CapitalizedCostBreakdownPDF} from "../../components/CapitalizedCostBreakdownPDF"
import {FooterPDF} from "../../components/FooterPDF"
import {BasePDF} from "../../BasePDF"
import {buildPdfFileName} from "../../pdfFileName"

export const CustomerDisclosurePDF = ({companyName, customerName, customerAddress, dealState, ...props}) => (
    <BasePDF dealState={dealState} {...props}>
        <Document title={buildPdfFileName(dealState, 'Customer')}>
            <Page size="A4" style={baseStyles.page} wrap={false}>
                <View style={baseStyles.container}>
                    <HeaderPDF
                        pdfName="Customer Worksheet"
                        companyName={companyName}
                        customerName={customerName}
                        customerAddress={customerAddress}
                    />
                    <VehicleInfoPDF/>

                    <View style={baseStyles.mainGrid}>
                        <View style={[baseStyles.column, baseStyles.columnLeft]}>
                            <AmountDueAtSigningPDF/>
                            <PaymentInformationPDF/>
                            <CapitalizedCostBreakdownPDF isCustomerWorksheet/>
                        </View>

                        <View style={[baseStyles.column, baseStyles.columnRight]}>
                            <TaxInformationPDF/>
                            <MileageInformationPDF/>
                            <ResidualInformationPDF isDealerDisclosure={false}/>
                            <FeeBreakdownPDF/>
                        </View>
                    </View>

                    <FooterPDF showCompanyLogo/>
                </View>
            </Page>
        </Document>
    </BasePDF>
)
